app.controller('StaffCustomerController', ['$rootScope', '$scope', '$http', '$state', function ($rootScope, $scope, $http, $state) {

    const staffCustomerModel = $rootScope.model.staff_customer;

    $scope.list_model = new $rootScope.model_constructor.ListModel({
        item_list: staffCustomerModel.choiceList(),
        in_progress: true
    });

    staffCustomerModel.requestCustomers(function () {
        $scope.list_model.cloneList(staffCustomerModel.choiceList());
    })

    $scope.showCustomer = function (customerCode) {
        $state.go('myba.staff-customer-entry', {customer_code: customerCode});
    };

}]);
